<template>
    <p class="title">{{title}}</p>
</template>

<script>
export default {
    name: "Title",
    props: {
        title: String
    }
}
</script>

<style scoped>
.title {
    color: #4c4c4c;
    font-size: 0.43rem;
    line-height: 1.5;
    margin-bottom: 0.2rem;
    font-family: "Microsoft YaHei", SimSun;
}
</style>
